<template>
  <div class="app">
    <div class="header-fixed">
      <AppHeader :name="name"/>
      <main class="main">
        <div class="app-body">
          <router-view :key="$route.fullPath"/>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader';

export default {
  name: 'full',
  components: {
    AppHeader,
  },
  data() {
    return {
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },

  },
  methods: {
  },
};
</script>
